module.exports = __webpack_public_path__ + "img/12.1718c5d8.png";